// src/main
import ReactDOM from 'react-dom/client';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import AppMain from './App';
import { Auth0ProviderWithNavigate } from './features/auth/Auth0/auth0-provider-with-navigate';
import { QueryRegistry } from './features/config/QueryRegistry';
import './index.css';

import '@/assets/illustrations/icons.css';
import { DevModeProvider } from '@/components/DevMode';
import { Toaster } from '@/components/Toast';
import { FeatureFlagProvider } from '@/config/featureFlags';
import {
  INITIAL_LOAD_TIMER_KEY,
  startPerfTimer,
} from '@/hooks/usePerformanceTracking';

const AUTO_CLOSE_DELAY = 15_000;

const Root = () => {
  return (
    <Auth0ProviderWithNavigate>
      <QueryRegistry>
        <FeatureFlagProvider>
          <DevModeProvider>
            <AppMain />
          </DevModeProvider>
        </FeatureFlagProvider>

        <ToastContainer
          hideProgressBar
          autoClose={AUTO_CLOSE_DELAY}
          position="top-right"
          style={{
            padding: '8px',
          }}
          transition={Slide}
        />
        <Toaster />
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryRegistry>
    </Auth0ProviderWithNavigate>
  );
};

const router = createBrowserRouter([{ path: '*', Component: Root }]);

// Start app_initial_load timer before React mounts, backdated to navigation
// start (performance.timeOrigin, epoch ms) so it includes HTML/bundle download
// — on a cold cache that's much of what the user waits through. Stopped by
// useInitialLoadTimer in each platform's root component once user resolves.
startPerfTimer(
  'app_initial_load',
  INITIAL_LOAD_TIMER_KEY,
  // Fall back if a webview reports no/zero timeOrigin — that would make
  // latency_ms NaN or ~Date.now().
  Math.round(performance.timeOrigin) || Date.now(),
);

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(<RouterProvider router={router} />);
}
